import script from "./EditTerminalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTerminalComponent.vue?vue&type=script&setup=true&lang=js"

import "./EditTerminalComponent.vue?vue&type=style&index=0&id=cf35963e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf35963e"]])

export default __exports__